<template>
  <transition :name="transitionName">
    <!-- class="back-to-ceiling" -->
    <!-- :style="customStyle" -->
    <div id="elevator" v-show="visible" :class="lift===1?'rocket-con':'rocket-con fly'" @click="backToTop" @mouseover="overtotop" @mouseleave="lefttotop">
      <!-- <div style="margin-top:5px;">
        <svg t="1603355204594" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="10968" width="32" height="32">
          <path d="M728.259928 951.502607c0 0 9.828663-59.030657-50.786316-131.1173 59.001318-165.502951 67.186981-316.218899 67.186981-316.218899s121.259297 27.872328 121.259297 147.459286c-0.029339 204.817604-137.659962 299.876912-137.659962 299.876912zM394.026703 879.592c0 0-81.211163-260.620939-81.211163-368.736233 0-48.644548 5.486448-91.920005 14.024182-131.205318l369.968483 0c8.596413 39.314652 14.1122 82.619449 14.1122 131.234657 0 106.472294-80.976448 368.706894-80.976448 368.706894l-235.917254 0zM511.706607 439.238554c-41.603117 0-75.343304 33.740187-75.343304 75.372643 0 41.603117 33.740187 75.372643 75.343304 75.372643s75.372643-33.740187 75.372643-75.372643c0.029339-41.632457-33.740187-75.372643-75.372643-75.372643zM495.511317 102.628846l0-102.628846 29.339293 0 0 100.017649c33.534812 24.410292 124.281245 102.042061 165.326915 251.584436l-356.765801 0c39.666724-145.434875 126.041602-222.215804 162.099593-248.973239zM295.740072 951.502607c0 0-137.630623-95.059309-137.630623-299.876912 0-119.586958 121.259297-147.459286 121.259297-147.459286s8.185663 150.715948 67.157641 316.218899c-60.644318 72.115982-50.786316 131.1173-50.786316 131.1173zM561.612744 966.641682l-24.586327-24.586327-26.199989 81.944645-31.158329-81.944645-21.300327 42.571314-31.158329-77.015644 168.759613 0-34.356312 59.030657z" p-id="10969" fill="#005f75"></path>
        </svg>
      </div> -->
    </div>
  </transition>
</template>

<script>
/*eslint-disable*/
export default {
  name: 'BackToTop',
  props: {
    visibilityHeight: {
      type: Number,
      default: 240
    },
    backPosition: {
      type: Number,
      default: 248
    },
    customStyle: {
      type: Object,
      default: function () {
        return {
          right: '50px',
          bottom: '50px',
          width: '42px',
          height: '42px',
          'border-radius': '4px',
          'line-height': '45px',
          background: '#e7eaf1'
        }
      }
    },
    transitionName: {
      type: String,
      default: 'fade'
    }
  },
  data() {
    return {
      visible: false,
      interval: null,
      isMoving: false,
      lift: 1
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll)
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll)
    if (this.interval) {
      clearInterval(this.interval)
    }
  },
  methods: {
    handleScroll() {
      this.visible = window.pageYOffset > this.visibilityHeight
    },
    overtotop() {
      // var lift = document.getElementById("elevator")
      // lift.add("fly")
      this.lift = 0
    },
    lefttotop() {
      this.lift = 1
    },
    backToTop() {
      if (this.isMoving) return
      const start = window.pageYOffset
      let i = 0
      this.isMoving = true
      this.interval = setInterval(() => {
        const next = Math.floor(this.easeInOutQuad(10 * i, start, -start, 380))
        if (next <= this.backPosition) {
          window.scrollTo(0, 0)
          // window.scrollTo(0, this.backPosition)
          clearInterval(this.interval)
          this.isMoving = false
        } else {
          window.scrollTo(0, next)
        }
        i++
      }, 16.7)
    },
    easeInOutQuad(t, b, c, d) {
      // 线性运动函数
      // d 为上升速度控制单元，越大越慢
      // b 点击返回头部时页面所处的位置
      if ((t /= d / 2) < 1) return c / 2 * t * t + b
      return -c / 2 * (--t * (t - 2) - 1) + b
    }
  }
}
</script>

<style scoped>
.rocket-con {
  position: fixed;
  /* background: url(//static.hdslb.com/bl2se/images/rocket_top.png); */
  background: url('../../../../static/img/totop/rocket_top.png');
  background-repeat: no-repeat;
  width: 150px;
  height: 175px;
  cursor: pointer;
  z-index: 99;
  bottom: 0;
  left: 60%;
  margin-left: 490px;
}
.back-to-ceiling {
  position: fixed;
  display: inline-block;
  text-align: center;
  cursor: pointer;
  border: #185d80;
}

.back-to-ceiling:hover {
  background: #d5dbe7;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.back-to-ceiling .Icon {
  fill: #005f75;
  background: none;
}

.fly {
  animation: fly 0.4s steps(1) infinite;
  /* background-image: url(//static.hdslb.com/bl2se/images/rocket_frame.png); */
  background: url('../../../../static/img/totop/rocket_frame.png');
}
@keyframes fly {
  0% {
    background-position-x: 0;
  }
  25% {
    background-position-x: -150px;
  }
  50% {
    background-position-x: -300px;
  }
  75% {
    background-position-x: -450px;
  }
  to {
    background-position-x: -600px;
  }
}
</style>



// WEBPACK FOOTER //
// src/common/component/BackToTop/index.vue